export const handleHeaderNavigation = ({ event, openSubMenu, headerWrapperRef }) => {
    var _a, _b;
    if (openSubMenu ||
        (event.key !== 'ArrowRight' && event.key !== 'ArrowDown' && event.key !== 'ArrowLeft' && event.key !== 'ArrowUp')) {
        return;
    }
    const elements = (_a = headerWrapperRef.current) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-header-keyboard-navigation], #searchtext-input');
    const searchTextElement = (_b = headerWrapperRef.current) === null || _b === void 0 ? void 0 : _b.querySelectorAll('#searchtext-input');
    const elementsToNavigate = Array.from(elements).filter((element) => {
        const currentElement = window.getComputedStyle(element);
        const parent = window.getComputedStyle(element.parentElement);
        return currentElement.display !== 'none' && parent.display !== 'none';
    });
    const firstElement = elementsToNavigate[0];
    const lastElement = elementsToNavigate[elementsToNavigate.length - 1];
    elementsToNavigate.forEach((_, index) => {
        if (elementsToNavigate[index] !== event.target) {
            return;
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            if (event.target === searchTextElement[0] || event.target === searchTextElement[1])
                return;
            event.preventDefault();
            const nextElement = elementsToNavigate[index + 1];
            return !nextElement ? firstElement.focus() : nextElement.focus();
        }
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            if (event.target === searchTextElement[0] || event.target === searchTextElement[1])
                return;
            event.preventDefault();
            const previousElement = elementsToNavigate[index - 1];
            return !previousElement ? lastElement.focus() : previousElement.focus();
        }
    });
};
